<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="7">
                    <input type="text" v-model="searchKantor" placeholder="Cari Kantor" class="form-control"/>
                </CCol>
                <CCol sm="3">
                    <input type="date" v-model="searchTanggal" placeholder="Tanggal Pelaksanaan" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Lokasi Tes</label>
                        <model-select style="margin-bottom:20px" :options="dataLokasi" class="form-control" v-model="lokasi" placeholder="Lokasi Tes"></model-select>
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != '' && lokasi.value == 'Y'">
                    <CCol sm="6">
                        <label>Nama Kantor</label>
                        <div class="autocomplete">
                            <input type="text"
                                    class="form-control"
                                    @click="toggleVisibleAddKantor()"
                                    @blur="toggleCloseVisibleAddKantor()"
                                    v-model.trim="$v.queryAddKantor.$model"
                                    :class="{ 'is-invalid':$v.queryAddKantor.$error, 'is-valid': !$v.queryAddKantor.$invalid }"
                                    v-text="selectedItemAddKantor ? selectedItemAddKantor['text'] : ''"
                                    @keydown.up="upAddKantor"
                                    @keydown.down="downAddKantor"
                                    @keydown.enter="selectItemAddKantor"
                                    placeholder="Pilih Kantor"
                            >
                            <div class="popovers" v-show="visibleAddKantor">
                                <div class="options" v-if="matchesAddKantor.length != 0 && queryAddKantor.length != 0" ref="optionsList">
                                    <ul>
                                    <li v-for="(match, index) in matchesAddKantor"
                                        :key="index"
                                        :class="{ 'selected': (selectedAddKantor == index)}"
                                        @click="itemClickedAddKantor(index)"
                                        v-text="match['text']"></li>
                                    </ul>
                                </div>
                                <div class="options" v-if="matchesAddKantor.length == 0 && queryAddKantor.length != 0">
                                    Data Tidak Ditemukan
                                </div>
                                <div class="options" v-if="matchesAddKantor.length == 0 && queryAddKantor.length == 0">
                                    Start Typing...
                                </div>
                            </div>
                        </div>
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != '' && lokasi.value == 'T'">
                    <CCol sm="6">
                        <label>Nama Lokasi Tes</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaLokasi.$model"
                            :class="{ 'is-invalid':$v.namaLokasi.$error, 'is-valid': !$v.namaLokasi.$invalid }"
                            placeholder="Nama Lokasi"
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Alamat Lokasi Tes</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.alamatLokasi.$model"
                            :class="{ 'is-invalid':$v.alamatLokasi.$error, 'is-valid': !$v.alamatLokasi.$invalid }"
                            placeholder="Alamat Lokasi"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != ''">
                    <CCol sm="6">
                        <label>Jenis Tes</label>
                        <model-select :options="dataJenisTest"
                            class="form-control model-select"
                            v-model.trim="$v.jenisTest.$model"
                            :class="{ 'is-invalid select-invalid':$v.jenisTest.$error, 'is-valid select-valid': !$v.jenisTest.$invalid }"
                            placeholder="Pilih Jenis Tes">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != ''">
                    <CCol sm="6">
                        <label>Tanggal Pelaksanaan</label>
                        <input 
                            class="form-control"
                            :min="getDateNow()"
                            v-model.trim="$v.addTanggal.$model"
                            :class="{ 'is-invalid':$v.addTanggal.$error, 'is-valid': !$v.addTanggal.$invalid }"
                            placeholder="Tanggal"
                            type="date"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Jam Pelaksanaan</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.addJam.$model"
                            :class="{ 'is-invalid':$v.addJam.$error, 'is-valid': !$v.addJam.$invalid }"
                            placeholder="Jam"
                            type="time"
                        />
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != ''">
                    <CCol sm="6">
                        <label>Kuota Peserta Tes</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.kuota.$model"
                            :class="{ 'is-invalid':$v.kuota.$error, 'is-valid': !$v.kuota.$invalid }"
                            placeholder="Kuota"
                            onkeypress="return ((event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46)" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Deskripsi Jadwal</label>
                        <input 
                            class="form-control" 
                            maxlength="200"
                            v-model.trim="$v.deskripsi.$model"
                            :class="{ 'is-invalid':$v.deskripsi.$error, 'is-valid': !$v.deskripsi.$invalid }"
                            placeholder="Deskripsi"
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != ''">
                    <CCol sm="6">
                        <label>Unit</label><br/>
                        <CButton class="w-25 btn btn-primary" @click="modalUnit = true">Tambah Unit</CButton>
                    </CCol>
                    <CCol sm="6">
                        <label>Peserta</label><br/>
                        <CButton class="w-25 btn btn-primary"  @click="modalPeserta = true">Tambah Peserta</CButton>
                    </CCol>
                </CRow>
                <CRow v-if="lokasi.value != ''" class="mt-3">
                    <CCol sm="6">
                        <label v-if="sumUnit.length != 0">Daftar Unit</label><br/>
                        <CRow v-if="sumUnit.length != 0">
                            <CCol sm="12" v-for="(li, id) in sumUnit" :key="id">
                                <CRow>
                                    <CCol sm="1">{{id+1}}.</CCol>
                                    <CCol sm="10">{{li.nama}}</CCol>
                                    <CCol sm="1"><img :src="closeIcon" @click="deleteSum('unit', id)" style="cursor:pointer" width="10px" height="10px"/></CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                    <CCol sm="6">
                        <label v-if="sumPeserta.length != 0">Daftar Peserta</label><br/>
                        <CRow v-if="sumPeserta.length != 0">
                            <CCol sm="12" v-for="(li, id) in sumPeserta" :key="id">
                                <CRow>
                                    <CCol sm="1">{{id+1}}.</CCol>
                                    <CCol sm="10">{{li.nama}}</CCol>
                                    <CCol sm="1"><img :src="closeIcon" @click="deleteSum('peserta', id)" style="cursor:pointer" width="10px" height="10px"/></CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton @click="submitForm('null')" class="btn btn-edit-submit mr-2">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
                <CButton v-if="(open == 'T' && tipe != 'C')" @click="submitForm('Y')" class="btn btn-edit-submit">
                    <span>Submit and Reopen</span>
                </CButton>
                <CButton v-if="(open == 'Y' && tipe != 'C')" @click="submitForm('T')" class="btn btn-edit-delete">
                    <span>submit and Close</span>
                </CButton>
            </CCol>
        </CRow>
        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalUnit"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Penambahan Unit</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalUnit = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mt-2 mb-5">
                        <CCol sm="12">
                            <label>Nama Unit</label>
                            <div class="autocomplete">
                                <input type="text"
                                        class="form-control"
                                        @click="toggleVisibleUnit()"
                                        @blur="toggleCloseVisibleUnit()"
                                        v-text="selectedItemUnit ? selectedItemUnit['text'] : ''"
                                        v-model="queryUnit"
                                        @keydown.up="upUnit"
                                        @keydown.down="downUnit"
                                        @keydown.enter="selectItemUnit"
                                        placeholder="Pilih Unit"
                                >
                                <div class="popovers" v-show="visibleUnit">
                                    <div class="options" v-if="matchesUnit.length != 0 && queryUnit.length != 0" ref="optionsList">
                                        <ul>
                                        <li v-for="(match, index) in matchesUnit"
                                            :key="index"
                                            :class="{ 'selected': (selectedUnit == index)}"
                                            @click="itemClickedUnit(index)"
                                            v-text="match['text']"></li>
                                        </ul>
                                    </div>
                                    <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length != 0">
                                        Data Tidak Ditemukan
                                    </div>
                                    <div class="options" v-if="matchesUnit.length == 0 && queryUnit.length == 0">
                                        Start Typing...
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </div>
                <CRow style="padding-left:40px;padding-right:40px" v-if="errUnit != ''"><span class="text-danger">*{{errUnit}}</span></CRow>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="8"></CCol>
                    <CCol sm="4">
                        <CButton style="width:100%!important" @click="modalUnit = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>

        <CModal
            size="lg"
            :centered="true"
            color="white"
            :show.sync="modalPeserta"
            :closeOnBackdrop="false"
            >
            <template #header-wrapper>
                <div class="headers-modal">
                    <CRow>
                        <CCol sm="10">
                            <div>Penambahan Peserta</div>
                        </CCol>
                        <CCol sm="2" class="text-right">
                            <img :src="closeIcon" @click="modalPeserta = false" style="cursor:pointer" width="20px" height="20px"/>
                        </CCol>
                    </CRow>
                </div>
            </template>
            <template #body-wrapper>
                <div style="padding-right:20px;padding-left:20px">
                    <CRow class="mt-2 mb-5">
                        <CCol sm="12">
                            <label>Nama Peserta</label>
                            <div class="autocomplete">
                                <input type="text"
                                        class="form-control"
                                        @click="toggleVisiblePeserta()"
                                        @blur="toggleCloseVisiblePeserta()"
                                        v-model="queryPeserta"
                                        v-text="selectedItemPeserta ? selectedItemPeserta['text'] : ''"
                                        @keydown.up="upPeserta"
                                        @keydown.down="downPeserta"
                                        @keydown.enter="selectItemPeserta"
                                        placeholder="Pilih Peserta"
                                >
                                <div class="popovers" v-show="visiblePeserta">
                                    <div class="options" v-if="matchesPeserta.length != 0 && queryPeserta.length != 0" ref="optionsList">
                                        <ul>
                                        <li v-for="(match, index) in matchesPeserta"
                                            :key="index"
                                            :class="{ 'selected': (selectedPeserta == index)}"
                                            @click="itemClickedPeserta(index)"
                                            v-text="match['text']"></li>
                                        </ul>
                                    </div>
                                    <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length != 0">
                                        Data Tidak Ditemukan
                                    </div>
                                    <div class="options" v-if="matchesPeserta.length == 0 && queryPeserta.length == 0">
                                        Start Typing...
                                    </div>
                                </div>
                            </div>
                        </CCol>
                    </CRow>
                </div>
                <CRow style="padding-left:40px;padding-right:40px" v-if="errPeserta != ''"><span class="text-danger">*{{errPeserta}}</span></CRow>
                <CRow class="mt-5" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                    <CCol sm="8"></CCol>
                    <CCol sm="4">
                        <CButton style="width:100%!important" @click="modalPeserta = false" class="btn-cancel">Kembali</CButton>
                    </CCol>
                </CRow>
            </template>
            <template #footer-wrapper><span></span></template>
        </CModal>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableJadwalTes'
import {DataApi} from "../../../service/DataApi";
import { ModelSelect } from 'vue-search-select'
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        queryAddKantor: {
            required
        },
        addTanggal: {
            required
        },
        addJam: {
            required
        },
        namaLokasi: {
            required
        },
        alamatLokasi: {
            required
        },
        deskripsi: {
            required
        },
        lokasi: {
            value: {
                required
            },
            text: {
                required
            }
        },
        jenisTest: {
            value: {
                required
            },
            text: {
                required
            }
        },
        kuota: {
            required
        }
    },
    data() {
        return {
            success: true,
            itemHeight: 39,

            // filter
            searchTanggal: '',

            // data search select kantor
            searchKantor: '',

            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            dataTh: ['Nama Kantor', 'Pelaksanaan', 'Daftar Peserta Khusus', 'Daftar Unit Khusus', 'Kuota', 'Status', 'Action'],
            dataTd: ['namaKantor', 'pelaksanaan', 'listPegawai', 'listUnit', 'kuota', 'status', 'action'],
            styleTable: ['175px', '150px', '200px', '200px', '100px', '100px', '125px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            tipe: 'C',
            addUnix: '',
            addTanggal: '',
            addJam: '',
            addTanggalExp: '',
            // data search select kantor
            dataAddKantor: [],
            titleAddKantor:"Pilih Kantor",
            selectedItemAddKantor: null,
            selectedAddKantor: 0,
            queryAddKantor: '',
            visibleAddKantor: false,
            idAddKantor: '',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,
            
            // datas
            datas: [],

            //error
            errorMessage: '',

            modalUnit: false,
            modalPeserta: false,

            // data peserta
            dataPeserta: [],
            titlePeserta:"Pilih Peserta",
            selectedItemPeserta: null,
            selectedPeserta: 0,
            queryPeserta: '',
            visiblePeserta: false,
            idPeserta: '',

            // data unit
            dataUnit: [],
            titleUnit:"Pilih Unit",
            selectedItemUnit: null,
            selectedUnit: 0,
            queryUnit: '',
            visibleUnit: false,
            idUnit: '',

            sumUnit: [],
            sumPeserta: [],
            errPeserta: '',
            errUnit: '',

            lokasi: {
                text: 'Lokasi tes di kantor',
                value: 'Y'
            },
            dataLokasi: [],
            jenisTest: {
                value: '',
                text: ''
            },
            dataJenisTest: [],
            alamatLokasi: '',
            namaLokasi: '',
            deskripsi: '',
            kuota: '',
            open: '',

            flagSearch: false,
            dateNow: new Date()
        }
    },
    computed: {
        matchesAddKantor() {
            if (this.queryAddKantor == '') {
                return [];
            }
            return this.dataAddKantor.filter((item) => item['text'].toLowerCase().includes(this.queryAddKantor.toLowerCase()))
        },
        matchesPeserta() {
            if (this.queryPeserta == '') {
                return [];
            }
            return this.dataPeserta.filter((item) => item['text'].toLowerCase().includes(this.queryPeserta.toLowerCase()))
        },
        matchesUnit() {
            if (this.queryUnit == '') {
                return [];
            }
            return this.dataUnit.filter((item) => item['text'].toLowerCase().includes(this.queryUnit.toLowerCase()))
        },
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        queryAddKantor() {
            if(this.queryAddKantor == '') {
                this.idAddKantor = ''
            }
            this.getDataAddKantor('null')
        },
        queryPeserta() {
            if(this.queryPeserta == '') {
                this.idPeserta = ''
            }
            this.getDataPeserta()
        },
        queryUnit() {
            if(this.queryUnit == '') {
                this.idUnit = ''
            }
            this.getDataUnit()
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        modalUnit() {
            if(this.modalUnit == false) {
                this.queryUnit = ''
                this.idUnit = ''
                this.errUnit = ''
            }
        },
        modalPeserta() {
            if(this.modalPeserta == false) {
                this.queryPeserta = ''
                this.idPeserta = ''
                this.errPeserta = ''
            }
        },
        lokasi() {
            if(this.lokasi.value == 'Y') {
                this.alamatLokasi = ''
                this.namaLokasi = ''
                this.$v.alamatLokasi.$reset()
                this.$v.namaLokasi.$reset()
            } else {
                this.queryAddKantor = ''
                this.idAddKantor = ''
                this.$v.queryAddKantor.$reset()
            }
        },
        searchKantor() {
            this.flagSearch = true
        },
        searchTanggal() {
            this.flagSearch = true
        },
    },
    methods: {
        /**
         * ADD SELECT KANTOR
         */
        getDataAddKantor(val) {
            let payload = ''
            if(val == 'null') {
                payload = {
                    kantorId: '',
                    kota: '',
                    limit: 10,
                    nama: this.queryAddKantor,
                    pageIn: 1,
                    provinsi: ''
                }
            } else {
                payload = {
                    kantorId: val,
                    kota: '',
                    limit: 10,
                    nama: '',
                    pageIn: 1,
                    provinsi: ''
                }
            }
            DataApi.post("kantor/get", payload)
            .then(res => {
                this.dataAddKantor = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].id,
                        text: tempData[i].nama 
                    }
                    this.dataAddKantor.push(onPush)
                }
                if(val != 'null') {
                    this.queryAddKantor = this.dataAddKantor[0].text
                    this.idAddKantor = this.dataAddKantor[0].value
                }
            })
        },
        toggleVisibleAddKantor() {
            this.visibleAddKantor = true;
        },
        hideAddKantor() {
            this.visibleAddKantor = false;
        },
        toggleCloseVisibleAddKantor() {
            setTimeout(this.hideAddKantor, 1000);
        },
        itemClickedAddKantor(index) {
            this.selectedAddKantor = index;
            this.selectItemAddKantor();
        },
        selectItemAddKantor() {
            if (!this.matchesAddKantor.length) {
            return;
            }
            this.selectedItemAddKantor = this.matchesAddKantor[this.selectedAddKantor];
            this.visibleAddKantor = false;
            this.queryAddKantor = this.selectedItemAddKantor.text
            this.idAddKantor = this.selectedItemAddKantor.value
            if (this.shouldReset) {
            this.queryAddKantor = '';
            this.selectedAddKantor = 0;
            }
        },
        upAddKantor() {
            if (this.selectedAddKantor == 0) {
            return;
            }
            this.selectedAddKantor -= 1;
            this.scrollToItemAddKantor();
        },
        downAddKantor() {
            if (this.selectedAddKantor >= this.matchesAddKantor.length - 1) {
            return;
            }
            this.selectedAddKantor += 1;
            this.scrollToItemAddKantor();
        },
        scrollToItemAddKantor() {
            this.$refs.optionsList.scrollTop = this.selectedAddKantor * this.itemHeight;
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.namaKantor.toLowerCase() < b.namaKantor.toLowerCase()) {
                        return -1
                    }
                    if (a.namaKantor.toLowerCase() > b.namaKantor.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.tanggal.toLowerCase() < b.tanggal.toLowerCase()) {
                        return -1
                    }
                    if (a.tanggal.toLowerCase() > b.tanggal.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.jam.toLowerCase() < b.jam.toLowerCase()) {
                        return -1
                    }
                    if (a.jam.toLowerCase() > b.jam.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let kantor = this.searchKantor
            let tanggal = this.searchTanggal
            let page = this.page

            let payload = {
                limit: limit,
                kantor: kantor,
                tanggal: tanggal,
                pageIn: page
            }
            DataApi.post("rta/jadwal/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchKantor = ''
            this.searchTanggal = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
                this.alertMess = ''
                this.currentAlertCounter = 0
            } else {
                this.goArea = true
                this.queryAddKantor = ''
                this.idAddKantor = ''
                this.addTanggal = ''
                this.addJam = ''
                this.addTanggalExp = ''
                this.sumPeserta = []
                this.sumUnit = []
                this.addUnix = ''
                this.deskripsi = ''
                this.lokasi.value = 'Y'
                this.lokasi.text = 'Lokasi tes di kantor'
                this.namaLokasi = ''
                this.alamatLokasi = ''
                this.kuota = ''
                this.jenisTest.value = ''
                this.jenisTest.text = ''
                this.dataJenisTest = []
                this.open = ''
                this.tipe = 'C'
                this.getDataAddKantor('null')
                this.getDataLokasi()
                this.getDataJenisTest('C', '')
                this.$v.$reset()
            }
        },
        goSave(vals) {
            this.$store.state.loadingScreen = true
            let flags = ''
            if(vals == 'null') {
                if(this.tipe == 'C') {
                    flags = 'Y'
                } else {
                    flags = this.open
                }
            } else {
                flags = vals
            }
            let flagKantor = ''
            let alamatKantor = ''
            let idKantor = ''

            if(this.lokasi.value == 'Y') {
                flagKantor = 'Y'
                alamatKantor = ''
                idKantor = this.idAddKantor
            } else if(this.lokasi.value == 'T') {
                if(this.tipe == 'C') {
                    idKantor = ''
                } else {
                    idKantor = this.idAddKantor
                }
                flagKantor = 'T'
                alamatKantor = this.namaLokasi + ' // ' + this.alamatLokasi
            }

            let x = '##'
            let peserta = ''
            let unit = ''
            var i,j
            if(this.sumPeserta.length != 0) {
                for(i=0;i<this.sumPeserta.length;i++) {
                    let list = this.sumPeserta[i].id
                    if(i==0) {
                        peserta += list
                    } else {
                        peserta += x + list
                    }
                }
            }
            if(this.sumUnit.length != 0) {
                for(j=0;j<this.sumUnit.length;j++) {
                    let lists = this.sumUnit[j].id
                    if(j==0) {
                        unit += lists
                    } else {
                        unit += x + lists
                    }
                }
            }
            let payload = {
                idPegawai: peserta,
                lvl: unit,
                idKantor: idKantor,
                kantor: flagKantor,
                lokasi: alamatKantor,
                jam: this.addJam,
                jenisTest: this.jenisTest.value,
                tanggal: this.addTanggal,
                tanggalExpired: this.addTanggalExp,
                tipe: this.tipe,
                unix: this.addUnix,
                description: this.deskripsi,
                open: flags,
                kuota: this.kuota
            }
            DataApi.post("rta/jadwal/simpan", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                        this.getData()
                        this.moving()
                        this.currentAlertCounter = 7
                        this.alertMess = response.data.Data2
                    } else {
                        this.loading = false
                        alert(response.data.Data2)
                    }
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.loading = false
                this.$store.state.loadingScreen = false
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            this.getDataJenisTest('U', value)
        },
        pharEdit(value) {
            let generate = this.datas[value]
            this.addTanggal = generate.tanggalOri
            this.addJam = generate.jam
            this.addTanggalExp = ''
            this.addUnix = generate.unix
            this.sumUnit = generate.listUnit
            this.sumPeserta = generate.listPegawai
            this.kuota = generate.kuota
            this.deskripsi = generate.deskripsi
            this.open = generate.open
            let flag = generate.kantor
            if(flag == 'Y') {
                this.lokasi.value = 'Y'
                this.lokasi.text = 'Lokasi tes di kantor'
                this.getDataAddKantor(generate.idKantor)
            } else if(flag == 'T')  {
                this.lokasi.value = 'T'
                this.lokasi.text = 'Lokasi tes bukan di Kantor'
                this.idAddKantor = generate.idKantor
                this.namaLokasi = generate.namaKantor.split(" // ")[0]
                this.alamatLokasi = generate.namaKantor.split(" // ")[1]
            }
            var i 
            for(i=0;i<this.dataJenisTest.length;i++) {
                if(this.dataJenisTest[i].value == generate.idJenisTest) {
                    this.jenisTest.value = this.dataJenisTest[i].value
                    this.jenisTest.text = this.dataJenisTest[i].text
                }
            }
            this.getDataAddKantor(generate.idKantor)
            this.tipe = 'U'
            this.moving()
        },

        /**
         * Validation
         */
        submitForm(vals) {
            this.$v.$touch()
            if(this.$v.$invalid) {
                if(this.$v.kuota.$invalid || this.$v.deskripsi.$invalid || this.$v.jenisTest.$invalid) {
                    //
                } else {
                    if(this.lokasi.value == 'Y') {
                        if(this.$v.namaLokasi.$invalid && this.$v.alamatLokasi.$invalid) {
                            this.goSave(vals)
                            this.loading = true
                        }
                    } else {
                        if(this.$v.queryAddKantor.$invalid) {
                            this.goSave(vals)
                            this.loading = true
                        }
                    }
                }
            } else {
                this.goSave(vals)
                this.loading = true
            }
        },
        deleteSum(val, id) {
            if(val == 'unit') {
                this.sumUnit.splice(id, 1)
            } else if('peserta') {
                this.sumPeserta.splice(id, 1)
            }
        },

        /**
         * SEARCH PESERTA
         */
        getDataPeserta() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 4,
                nama: this.queryPeserta,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPeserta = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].idPegawai,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPeserta.push(onPush)
                }
            })
        },
        toggleVisiblePeserta() {
            this.visiblePeserta = true;
        },
        hidePeserta() {
            this.visiblePeserta = false;
        },
        toggleCloseVisiblePeserta() {
            setTimeout(this.hidePeserta, 1000);
        },
        itemClickedPeserta(index) {
            this.selectedPeserta = index;
            this.selectItemPeserta();
        },
        selectItemPeserta() {
            if (!this.matchesPeserta.length) {
            return;
            }
            this.selectedItemPeserta = this.matchesPeserta[this.selectedPeserta];
            this.visiblePeserta = false;
            this.queryPeserta = this.selectedItemPeserta.text
            this.idPeserta = this.selectedItemPeserta.value
            var i = 0
            let data = this.sumPeserta
            let onPush = ''
            if(data.length == 0) {
                onPush = {
                    nama: this.queryPeserta.split(" - ")[0],
                    id: this.idPeserta
                }
                this.sumPeserta.push(onPush)
                this.modalPeserta = false
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].id == this.idPeserta) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    onPush = {
                        nama: this.queryPeserta.split(" - ")[0],
                        id: this.idPeserta
                    }
                    this.sumPeserta.push(onPush)
                    this.modalPeserta = false
                } else {
                    this.errPeserta = 'Data sudah ada pada list'
                }
            }
            if (this.shouldReset) {
            this.queryPeserta = '';
            this.selectedPeserta = 0;
            }
        },
        upPeserta() {
            if (this.selectedPeserta == 0) {
            return;
            }
            this.selectedPeserta -= 1;
            this.scrollToItemPeserta();
        },
        downPeserta() {
            if (this.selectedPeserta >= this.matchesPeserta.length - 1) {
            return;
            }
            this.selectedPeserta += 1;
            this.scrollToItemPeserta();
        },
        scrollToItemPeserta() {
            this.$refs.optionsList.scrollTop = this.selectedPeserta * this.itemHeight;
        },

        /**
         * SEARCH UNIT LEVEL
         */
        getDataUnit() {
            let payload = {
                limit: 4,
                namaUnit: this.queryUnit,
                pageIn: 1,
                namaParentUnit: '',
                idUnit: ''
            }
            DataApi.post("unit/get", payload)
            .then(res => {
                this.dataUnit = []
                let response = res.data.data
                let tempData = response.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = ''
                    if(tempData[i].parentBidang == null || tempData[i].parentBidang == 'null') {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang
                        }                      
                    } else {
                        onPush = {
                            value: tempData[i].id,
                            text: tempData[i].bidang + ' - ' + tempData[i].parentBidang                            
                        }
                    }
                    this.dataUnit.push(onPush)
                }
            })
        },
        toggleVisibleUnit() {
            this.visibleUnit = true;
        },
        hideUnit() {
            this.visibleUnit = false;
        },
        toggleCloseVisibleUnit() {
            setTimeout(this.hideUnit, 1000);
        },
        itemClickedUnit(index) {
            this.selectedUnit = index;
            this.selectItemUnit();
        },
        selectItemUnit() {
            if (!this.matchesUnit.length) {
            return;
            }
            this.selectedItemUnit = this.matchesUnit[this.selectedUnit];
            this.queryUnit = this.selectedItemUnit.text
            this.idUnit = this.selectedItemUnit.value
            var i = 0
            let data = this.sumUnit
            let onPush = ''
            if(data.length == 0) {
                onPush = {
                    nama: this.queryUnit.split(" - ")[0],
                    id: this.idUnit
                }
                this.sumUnit.push(onPush)
                this.modalUnit = false
            } else {
                var j = 0
                let status = false
                for(j=0;j<data.length;j++) {
                    if(data[j].id == this.idUnit) {
                        status = true
                        break
                    } else {
                        status = false
                    }
                }
                if(status == false) {
                    onPush = {
                        nama: this.queryUnit.split(" - ")[0],
                        id: this.idUnit
                    }
                    this.sumUnit.push(onPush)
                    this.modalUnit = false
                } else {
                    this.errUnit = 'Data sudah ada pada list'
                }
            }
            this.visibleUnit = false;
            if (this.shouldReset) {
            this.queryUnit = '';
            this.selectedUnit = 0;
            }
        },
        upUnit() {
            if (this.selectedUnit == 0) {
            return;
            }
            this.selectedUnit -= 1;
            this.scrollToItemUnit();
        },
        downUnit() {
            if (this.selectedUnit >= this.matchesUnit.length - 1) {
            return;
            }
            this.selectedUnit += 1;
            this.scrollToItemUnit();
        },
        scrollToItemUnit() {
            this.$refs.optionsList.scrollTop = this.selectedUnit * this.itemHeight;
        },
        getDataLokasi() {
            this.dataLokasi = [
                { value: 'Y', text: 'Lokasi tes di kantor' },
                { value: 'T', text: 'Lokasi tes bukan di Kantor' },
            ]
        },
        getDataJenisTest(val, value) {
            let payload = {
                tipe: '2'
            }
            DataApi.post("rta/jenis/lihat", payload)
            .then(res => {
                this.dataJenisTest = []
                let response = res.data
                if(response.success == true) {
                    let temp = response.data
                    var i 
                    for(i=0;i<temp.length;i++) {
                        let onPush = {
                            value: temp[i].unix,
                            text: temp[i].keterangan
                        }
                        this.dataJenisTest.push(onPush)
                    }
                }
            })
            if(val == 'U') {
                this.pharEdit(value)
            }
        },
        getDateNow() {
            let now = this.dateNow
            let tanggal = now.getDate()
            let bulan = now.getMonth()+1
            if(bulan != 10 && bulan != 11 && bulan != 12) {
                bulan = '0'+ bulan
            }
            let tahun = now.getFullYear()
            return tahun + '-' + bulan + '-' + tanggal
        },
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataLokasi()
        this.getDataJenisTest('C', '')
    },
}
</script>
<style scoped>
input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin-right: 8px;
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}
.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}
.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select, .area-input .autocomplete {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 64px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 32px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 40px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: scroll;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
</style>